import { render } from "./BlogDetal.vue?vue&type=template&id=855edb1e&scoped=true"
import script from "./BlogDetal.vue?vue&type=script&lang=js"
export * from "./BlogDetal.vue?vue&type=script&lang=js"

import "./BlogDetal.vue?vue&type=style&index=0&id=855edb1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-855edb1e"]])

export default __exports__